import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { EmptyComponent, EmptyProps } from '@core/components/empty/empty.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { logger } from '@core/helpers/logger';

import { Content, ContentTypeEnum } from 'lingo2-models';
import { InViewportModule } from 'ng-in-viewport';

@Component({
  selector: 'app-favorites-lessons',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    InViewportModule,

    LibraryElementsModule,
    ModalModule,
    MobileModalModule,
    FilterContentComponent,
    EmptyComponent,
    ContentCardModule,
  ],
  templateUrl: './favorites-lessons.component.html',
  styleUrls: ['./favorites-lessons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoritesLessonsComponent extends AbstractContentPane {
  private location = inject(Location);

  public filterTabs = [
    {
      id: -1,
      code: null,
      title: 'content.tabs-all',
    },
    {
      id: 1,
      code: ContentTypeEnum.exercise,
      title: 'content-type-title.exercise',
    },
    {
      id: 2,
      code: ContentTypeEnum.theory,
      title: 'content-type-title.theory',
    },
    {
      id: 3,
      code: ContentTypeEnum.video,
      title: 'content-type-title.video',
      count: 2,
    },
    {
      id: 4,
      code: ContentTypeEnum.audio,
      title: 'content-type-title.audio',
    },
  ];
  public selectedTab = this.filterTabs[0];
  public showModal = false;
  public item: Content = null;

  private originalUrl: string;

  public emptyObj: Partial<EmptyProps> = {
    text: 'favorites.empty-message',
    image: 'favorites',
    link_label: 'favorites/lessons.empty',
    link: '/lessons',
    link2: '/lessons',
  };

  hasContent(): boolean {
    return true;
  }

  protected onContentLoaded() {
    this.isVisible = true;
  }

  public trackContentByFn(index, item: Content): string {
    return item.id;
  }

  public onInViewportBottomChange(reached) {
    logger.debug('FavoritesLessonsComponent::', reached);
    if (reached.visible) {
      this.loadNextPage();
    }
  }

  public onSelectItem(item): void {
    if (this.selectedTab.id === item.id) {
      return;
    }
    this.selectedTab = item;

    this._pane = {
      ...this._pane,
      loaded: false,
      contentFilter: {
        ...this._pane.contentFilter,
        content_type: this.selectedTab.code,
      },
      content: [],
    };
    if (!this.selectedTab.code) {
      delete this._pane.contentFilter.content_type;
    }
    this.loadPane();
  }

  public onOpenCard(content: Content) {
    this.item = content;
    this.showModal = true;
    const url = this.contentRoute(this.item);
    const currentUrl = this.location.path(false);
    if (currentUrl !== url) {
      this.originalUrl = currentUrl;
      this.location.replaceState(url);

      // отправка событий в аналитику для имитации навигации по страницам
      this.analytics.pageView(url, currentUrl);
    }
    this.detectChanges();
  }

  public onCloseModal(e) {
    this.showModal = !e;
    if (this.originalUrl) {
      this.location.replaceState(this.originalUrl);
    }
    this.detectChanges();
  }

  public onFavoriteChanged(contentId: string) {
    const index = this.content.findIndex((content) => content.id === contentId);
    if (index < 0) {
      return;
    }
    this.content.splice(index, 1);
    this.onCloseModal(true);
  }
}
